// imports
import { FC } from 'react';
// component
import SidebarMain from 'components/common/SidebarMain';
//constants
import { SUPER_ADMIN_GENERAL_LIST } from 'constants/index';

const GeneralList: FC = () => <SidebarMain list={SUPER_ADMIN_GENERAL_LIST} />;

export default GeneralList;
